(function () {
  function scrollToJoin() {
    var join = document.getElementById('join');
    if (!join) return;
    join.scrollIntoView({ behavior: 'smooth' });
  }

  async function handleSubmit(event) {
    if (!event || !event.preventDefault) return;
    event.preventDefault();

    var form = event.target;
    if (!form) return;

    var submitButton = form.querySelector('.cta-button');
    var originalText = submitButton ? submitButton.textContent : '';

    if (submitButton) {
      submitButton.textContent = 'Submitting...';
      submitButton.disabled = true;
    }

    try {
      var formData = new FormData(form);
      var data = Object.fromEntries(formData);

      var SCRIPT_URL =
        'https://script.google.com/macros/s/AKfycbycu8Iy3IT2Pmg4ZiHoqdSWy1zvfMpPPURx5764ICMvb0J7_17SnJMqPlFzI5R59kHKUw/exec';

      var params = new URLSearchParams();
      params.append('name', data.name || '');
      params.append('phone', data.phone || '');
      params.append('dob', data.dob || '');

      var response = await fetch(SCRIPT_URL, {
        method: 'POST',
        body: params,
      });

      var result = await response.text();
      // eslint-disable-next-line no-console
      console.log('Response:', result);

      alert(
        'Thank you for your application! If selected, our team will contact you within 7-10 business days.'
      );
      form.reset();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error:', error);
      alert('There was an error submitting your application. Please try again.');
    } finally {
      if (submitButton) {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
      }
    }
  }

  function initGalleryImages() {
    var images = document.querySelectorAll('.kisaansay-gallery .gallery-item img');
    if (!images.length) return;

    images.forEach(function (img) {
      function show() {
        img.style.opacity = '1';
      }

      if (img.complete) show();
      img.addEventListener('load', show);

      img.addEventListener('error', function () {
        img.style.background = 'linear-gradient(135deg, #CF2930, #FBE70C)';
        img.style.opacity = '0.8';
      });
    });
  }

  function restartGalleryAnimation() {
    var gallery = document.querySelector('.kisaansay-gallery .gallery-grid');
    if (!gallery) return;

    gallery.style.animation = 'none';
    // Trigger reflow
    // eslint-disable-next-line no-unused-expressions
    gallery.offsetHeight;

    if (window.innerWidth <= 480) {
      gallery.style.animation = 'smallMobileInfiniteSlide 60s linear infinite';
    } else if (window.innerWidth <= 768) {
      gallery.style.animation = 'mobileInfiniteSlide 60s linear infinite';
    } else {
      gallery.style.animation = 'infiniteSlide 45s linear infinite';
    }
  }

  function initGalleryAnimationGuards() {
    var grid = document.querySelector('.kisaansay-gallery .gallery-grid');
    if (!grid) return;

    restartGalleryAnimation();
    window.addEventListener('resize', restartGalleryAnimation);

    if (window.innerWidth <= 768) {
      window.setInterval(function () {
        var g = document.querySelector('.kisaansay-gallery .gallery-grid');
        if (!g) return;
        var computedStyle = window.getComputedStyle(g);
        if (
          computedStyle.animationPlayState === 'paused' ||
          computedStyle.animationName === 'none'
        ) {
          restartGalleryAnimation();
        }
      }, 3000);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGalleryImages();
    initGalleryAnimationGuards();
  });

  window.scrollToJoin = scrollToJoin;
  window.handleSubmit = handleSubmit;
})();

